import * as z from "zod/v4";

export const contactFormSchema = z.object({
	name: z.string().min(1, "Please enter your name"),
	email: z.email().transform((val) => val.toLowerCase()),
	phone: z.string().min(1, "Please enter your phone number"),
	message: z.string().min(1, "Please enter your message"),
	turnstileToken: z.string().optional()
});

export type ContactFormSchema = typeof contactFormSchema;
